/*
 * Copyright (c) 2024. Tooling Team
 */

import React from "react";
import { ThemeProvider } from "@uhg-abyss/web/ui/ThemeProvider";
import { ToastProvider } from "@uhg-abyss/web/ui/Toast";
import { createTheme } from "@uhg-abyss/web/tools/theme";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { AuthProvider } from "./providers/authProvider";
import { Routes } from "./routes/routes";
import { store } from "./app/store";

const theme = createTheme("optum");

function App() {
  // remove enabled prop to run without auth
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider />
      <Provider store={store}>
        <AuthProvider enabled>
          <Router basename="/">{Routes}</Router>
        </AuthProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
